var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { updateDataFromCollection } from './utils';
const initialState = {
    data: [],
    count: 0,
};
export const createPostBoardLink = createAsyncThunk('reduxPostBoardLinks/create', (postBoardlinks_1, _a) => __awaiter(void 0, [postBoardlinks_1, _a], void 0, function* (postBoardlinks, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.postBoardLinks.collection.create(postBoardlinks);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const updatePostBoardLink = createAsyncThunk('reduxPostBoardLinks/update', (updatedPostBoardsLinks_1, _a) => __awaiter(void 0, [updatedPostBoardsLinks_1, _a], void 0, function* (updatedPostBoardsLinks, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.postBoardLinks.collection.update(updatedPostBoardsLinks);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const { actions, reducer } = createSlice({
    name: 'reduxPostBoardLinks',
    initialState,
    reducers: {
        setAllPostBoardLinks: (state, { payload }) => {
            state.data = payload;
        },
    },
    extraReducers: (builder) => {
        // CREATE
        builder.addCase(createPostBoardLink.pending, (state, { payload }) => { });
        builder.addCase(createPostBoardLink.fulfilled, (state, { payload }) => {
            const newData = [...state.data, ...payload];
            state.data = newData;
        });
        builder.addCase(createPostBoardLink.rejected, (state, { payload }) => { });
        // UDPDATE
        builder.addCase(updatePostBoardLink.pending, (state, { payload }) => { });
        builder.addCase(updatePostBoardLink.fulfilled, (state, { payload }) => {
            const newData = updateDataFromCollection(state.data, payload);
            state.data = newData;
        });
        builder.addCase(updatePostBoardLink.rejected, (state, { payload }) => { });
    },
});
export const { setAllPostBoardLinks } = actions;
export default reducer;
